module.exports = __webpack_public_path__ + "img/1F62B.ca529a32.svg";